module.exports = __webpack_public_path__ + "static/media/20import-46.cb5adf1c.xlsx";